'use strict';

exports.__esModule = true;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _container = require('../container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestBuilder = function requestBuilder(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      body = _ref.body,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'get' : _ref$method,
      _ref$headers = _ref.headers,
      headers = _ref$headers === undefined ? _container2.default.getDefinition('requestHeaders').getArguments() : _ref$headers;

  var finalHeaders = (0, _isFunction2.default)(headers) ? headers(_container2.default.getDefinition('requestHeaders').getArguments()) : headers;

  return new Request(url, {
    method: method,
    headers: finalHeaders,
    body: (0, _isObject2.default)(body) && !(body instanceof FormData) ? JSON.stringify(body) : body
  });
};

exports.default = requestBuilder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/requestBuilder.js
// module id = 686
// module chunks = 0